<shared-link-container
  class="flex overflow-hidden border-radius-3"
  [routerLink]="routerLink"
  [isActive]="isSelected"
  [contentStyleClass]="contentStyleClass"
  [showArrowIcon]="showArrowIcon">
  <div class="flex align-items-center gap-2">
    <div class="layout-fr-auto gap-2 flex-grow-1">
      <h2 class="headline">{{ headline }}</h2>

      @if (description) {
        <div class="description">{{ description }}</div>
      }
    </div>

    @if (help) {
      <shared-icon
        class="fill-dark pointer ml-auto"
        icon="info-square"
        width="1.5rem"
        height="1.5rem"
        (click)="showInfoModal()" />
    }

    @if (imagePath) {
      <img class="image" [src]="imagePath" />
    }
  </div>
</shared-link-container>
